import { useLang } from "@/i18n";

export const Marquee = () => {
  const { t } = useLang();
  const items = t.services.items.map((s) => s[0]);
  const sequence = [...items, ...items, ...items, ...items];
  return (
    <section
      className="relative overflow-hidden border-y border-[var(--line)] bg-[var(--bg-0)] py-8 md:py-12"
      data-testid="marquee-section"
      aria-hidden="true"
    >
      <div className="marquee-track">
        {sequence.map((word, i) => (
          <span
            key={i}
            className={`font-heading font-black text-5xl md:text-7xl tracking-tight px-6 md:px-10 ${
              i % 2 === 0 ? "stroke-text" : "text-[var(--txt)]"
            }`}
          >
            {word}
            <span className="text-[var(--accent)] mx-6 md:mx-10">·</span>
          </span>
        ))}
      </div>
    </section>
  );
};
